

import Divider from 'vux/src/components/divider/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default{
props: {
eventHub: Object,
liveUrl: String,
isEnd: Boolean
},
directives: {
TransferDom
},
data(){
return {
matchId: '',//352917
content: '直播',
indexContentHeight: 0,
showHideOnBlur: false,
url: this.liveUrl,
matchEnd: this.isEnd
}
},
watch: {
liveUrl(val) {
console.log('==========watch liveUrl==============')
console.log(val)
this.url = val
},
isEnd(val) {
console.log('==========watch isEnd==============')
console.log(val)
this.matchEnd = val
}
},
created(){
this.matchId = this.$route.query.matchId;
},
mounted(){

this.initTab();
},
methods: {
initTab(){
this.$nextTick(() => {
this.indexContentHeight = document.body.clientHeight;
})
},
jump: function () {
window.open(this.url, '_blank');
}
},
components: {
Divider,
XDialog,
XButton,
Group,
XSwitch,
}
}



// WEBPACK FOOTER //
// ./src/views/matchLive.vue